module.exports = __webpack_public_path__ + "img/pill_icon.8b5f2ce4.svg";